import worldmap from '@/components/worldmap.vue'
import ThePlaceHolder from '@/components/ThePlaceHolder'
import { mapActions, mapGetters } from 'vuex'
import chart from '@/components/chart.vue'
import dashboardEntitledModal from '@/components/dashboardEntitledModal.vue'
import $ from 'jquery'
import Base64 from 'js-base64'
import localStorage from '@/api/localStorage'
import { SITE_URL } from '@/api/config'

import {
  REMOVETAB,
  ADDTAB,
  FETCH_TABS,
  FETCH_DASHBOARD_MARKET_VIEW,
  FETCH_DASHBOARD_SECTOR_SUMMARY,
  FETCH_DASHBOARD_EQUITY_RESEARCH,
  FETCH_DASHBOARD_FOCUS_LIST,
  FETCH_FEATURE,
  RESET_SEARCH_FILTER,
  SET_RESEARCH_TYPE,
  FETCH_DASHBOARD_APAC,
  FETCH_DASHBOARD_EUROPE,
  FETCH_DASHBOARD_LATAM,
  FETCH_DASHBOARD_RESEARCHCH_ANALYST_MORING_CALL,
  FETCH_DASHBOARD_MONTHLY_REPORTS,
  FETCH_LARGE_CAP,
  FETCH_WHITE_PAPERS,
  FETCH_IOP_LISTING,
  FETCH_ECON_SUMMARY,
  FETCH_EREADER,
  FETCH_TREND_WATCH,
  FETCH_ASIA_WATCH,
  FETCH_WON_EUROPE_TODAY,
  FETCH_GLOBAL_LAGGARDS,
  FETCH_WON_GLOBAL_VIEW,
  FETCH_STRATEGY_VIEW,
  SET_ANALYST_SEARCH,
  FETCH_ANALYST_BIO,
  SET_VIMEO_THUMBNAIL,
  RESET_TIME_STATE,
  RESET_ORDER_BY_FROM_HOME,
  FETCH_DASHBOARD_WEBINAR,
  FETCH_DASHBOARD_CAFL,
  FETCH_DERIVATIVES_REPORT,
  FETCH_DASHBOARD_YOUR_EBOOK,
  FETCH_FEATURE_SINGLE_POST,
  FETCH_US_MARKET_OVERVIEW,
  FETCH_Analyst_Insights_Video_Series,
  FETCH_SECTOR_SPOTLIGHT
} from '@/store/actions.type'
// import events from '@/events/tabs'
export default {
  name: 'dashboard',
  created() {
    this.fetchanalystinsightsvideo()
    this.fetchyoureookPost()
    this.fetchWonEuropeToday()
    this.fetchderivativesreport()
    this.fetchusmarketoverview()
    this.fetchfeaturepost()
    this.fetchfeaturethirdpost()
    this.fetchGlobalLaggards()
    this.fetchWonGlobalView()
    this.fetchStrategyView()
    this.fetchMarketView()
    this.fetchEuropePost()
    this.fetchlargecap()
    this.fetchSectorsummaryView()
    this.fetchequityResearchView()
    this.fetchfoucsList()
    this.fetchApacPost()
    //  this.fetchCaflPost()
    this.fetchereaderPost()
    this.fetchLatamPost()
    this.fetchmonthlyreports()
    this.fetchwhitepapers()
    this.fetchIPOlisting()
    this.fetchEconomicSummary()
   // this.fetchTrendWatch()
    //this.fetchAsiaWatch()
    this.fetchresearchanalystmorningcall()
    this.getresearchWebinar()
    this.fetchSectorSpotlight()

    // this.mousemove()
  },
  components: {
    worldmap,
    ThePlaceHolder,
    chart,
    dashboardEntitledModal,
    Base64
  },

  data() {
    return {
      yourebookLoading: true,
      marketViewLoading: true,
      SectorsummaryLoading: true,
      equityresearchLoading: true,
      focuslistLoading: true,
      globaloutlookLoading: true,
      featureLoading: true,
      researchanalystmorningcallLoading: true,
      researchWebinarLoading: true,
      monthlyreportsLoading: true,
      ereaderLoading: true,
      largecapLoading: true,
      apacLoading: true,
      europeLoading: true,
      latamLoading: true,
      ipolistingLoading: true,
      economicSummaryLoading: true,
      trendWatchLoading: true,
      asiaWatchLoading: true,
      wonEuropeTodayLoading: true,
      derivativesreportloading: true,
      globalLaggardsLoading: true,
      wonGlobalViewLoading: true,
      strategyViewLoading: true,
      whitepapersLoading: true,
      getvimeothumbsrcloading: true,
      usmarketoverviewLoading: true,
      analystinsightsvideoseriesloading: true,
      SectorSpotlightLoading: true,
      caflLoading: true,
      wonGlobalViewData: {},
      categoryNameEntlititment: '',
      video: '',
      source: '',
      types: /(\.|\/)(mp3|mp4)$/i,
      urlv: '',
      videoUrl: '',
      modalShow: false,
      imageurl: '',
      videoiframe: '',
      uNmae: this.$store.state.auth.user.username,
      uEmail: this.$store.state.auth.user.email,
      vimeoUrl: '',
      theme: this.$store.state.appsetting.theme,
	  iframurl: SITE_URL + 'research/dashboard/global-outlook/'
    }
  },
  watch: {
    modalShow: function () {
      if ( this.modalShow === false ) {
        $( '.youTubeVideo' ).attr( 'src', '' )
      } else {
        this.source = 'https://www.youtube.com/watch?v=qIJywY5mm8c'
        if ( !this.types.test( this.source ) ) {
          this.videoUrl = this.source.replace( /^.*?(\?|&)(v=([^&]+)).*$/i, '$3' )
          this.urlv = 'https://www.youtube.com/embed/' + this.videoUrl
          this.video =
            '<iframe class="youTubeVideo" width="100%" height="450" src="' +
            this.urlv +
            '"></iframe>'
        } else {
          this.video =
            '<video width="100%" height="100%" controls><source src="' +
            this.source +
            '" type="video/mp4"></video>'
        }
      }
    }
  },
  computed: {
    dashboardstore() {
      return this.$store.state.dashboard
    },
    marketviewData() {
      return this.dashboardstore.marketView.data
    },
    sectorSummaryData() {
      return this.dashboardstore.sectorsummary.data
    },
    usMarketoverviewData() {
      return this.dashboardstore.usmarketoverview.data
    },
    analystinsightsvideoData() {
      return this.dashboardstore.analystinsights.data
    },
    equityResearchData() {
      return this.dashboardstore.equityresearch.data
    },
    focusListData() {
      return this.dashboardstore.focuslist.data
    },
    yourebookData() {
      return this.dashboardstore.yourebook.data
    },
    sectorspotlightData() {
      return this.dashboardstore.sectorspotlight.data
    },

    featureData() {
      return this.dashboardstore.feature.data
    },
    researchanalystmorningcallData() {
      return this.dashboardstore.researchanalystmorningcall.data
    },
    researchWebinarData() {
      return this.dashboardstore.webinar.data
    },
    featuresinglepostData() {
      return this.dashboardstore.featuresinglepost.data
    },
    monthlyreportsData() {
      return this.dashboardstore.monthlyreports.data
    },
    largecapData() {
      return this.dashboardstore.largecap.data
    },
    apacData() {
      return this.dashboardstore.apac.data
    },
    caflData() {
      return this.dashboardstore.cafl.data
    },
    europeData() {
      return this.dashboardstore.europe.data
    },
    latamData() {
      return this.dashboardstore.latam.data
    },
    ipolistingData() {
      return this.dashboardstore.ioplisting.data
    },
    economicSummaryData() {
      return this.dashboardstore.econsummary.data
    },
    trendWatchData() {
      return this.dashboardstore.trendwatch.data
    },
    asiaWatchData() {
      return this.dashboardstore.asiawatch.data
    },
    globalLaggardsData() {
      return this.dashboardstore.globallaggards.data
    },
    strategyViewData() {
      return this.dashboardstore.strategyview.data
    },
    whitepapersData() {
      return this.dashboardstore.whitepapers.data
    },
    wonEuropeTodayData() {
      return this.dashboardstore.woneuropetoday.data
    },
    derivativesreports() {
      return this.dashboardstore.derivativesreports.data
    },
    ereaderData() {
      return this.dashboardstore.ereader.data
    },
    vimeoimg() {
      this.imageurl = this.dashboardstore.vimeoimg
      return this.dashboardstore.vimeoimg
    }
  },
  methods: {
    ...mapActions( {
      fetchyoureookdata: FETCH_DASHBOARD_YOUR_EBOOK,
      fetchMarketViewPost: FETCH_DASHBOARD_MARKET_VIEW,
      fetchsectorsummaryPost: FETCH_DASHBOARD_SECTOR_SUMMARY,
      fetchequityResearchPost: FETCH_DASHBOARD_EQUITY_RESEARCH,
      fetchfocusListPost: FETCH_DASHBOARD_FOCUS_LIST,
      fetchfeature: FETCH_FEATURE,
      fetchfeaturesingle: FETCH_FEATURE_SINGLE_POST,
      createRvTab: ADDTAB,
      resetSearchFilter: RESET_SEARCH_FILTER,
      setSearchcategory: SET_RESEARCH_TYPE,
      getapacPost: FETCH_DASHBOARD_APAC,
      getcaflPost: FETCH_DASHBOARD_CAFL,
      getEuropePost: FETCH_DASHBOARD_EUROPE,
      getLatamPost: FETCH_DASHBOARD_LATAM,
      getresearchanalystmorningcallPost: FETCH_DASHBOARD_RESEARCHCH_ANALYST_MORING_CALL,
      getmonthlyreports: FETCH_DASHBOARD_MONTHLY_REPORTS,
      getlargecap: FETCH_LARGE_CAP,
      getwhitepapers: FETCH_WHITE_PAPERS,
      getipolisting: FETCH_IOP_LISTING,
      geteconomicSummary: FETCH_ECON_SUMMARY,
      gettrendWatch: FETCH_TREND_WATCH,
      getasiaWatch: FETCH_ASIA_WATCH,
      getwonEuropeToday: FETCH_WON_EUROPE_TODAY,
      getderivativesreport: FETCH_DERIVATIVES_REPORT,
      getusmarketoverview: FETCH_US_MARKET_OVERVIEW,
      getanalystinsightsvideoseries: FETCH_Analyst_Insights_Video_Series,
      getglobalLaggards: FETCH_GLOBAL_LAGGARDS,
      getwonGlobalView: FETCH_WON_GLOBAL_VIEW,
      getstrategyView: FETCH_STRATEGY_VIEW,
      analystbio: FETCH_ANALYST_BIO,
      setsearchanalyst: SET_ANALYST_SEARCH,
      getvimeothumbsrcstore: SET_VIMEO_THUMBNAIL,
      resettime: RESET_TIME_STATE,
      orderby: RESET_ORDER_BY_FROM_HOME,
      getresearchWebinarPost: FETCH_DASHBOARD_WEBINAR,
      fetchSectorSpotlightPost: FETCH_SECTOR_SPOTLIGHT,
      fetchereader: FETCH_EREADER

    } ),
    ...mapGetters( ['activeTabIndex'] ),
    // 'createTab(sectorSummaryData.name,"post",sectorData)'
    async createTab( categoryName, type, post ) {
      // console.log("==============");
      // console.log(type);
      //  console.log(categoryName)
      window.scrollTo( 0, 0 )
      var tabobj = {}
      tabobj['type'] = type
      tabobj['categoryName'] = categoryName.slice( 0, 24 ) + ( categoryName.length > 24 ? '...' : '' )
      //    tabobj['categoryName'] = categoryName
      tabobj['post'] = post
      this.createRvTab( tabobj )
      var currentTab = this.activeTabIndex()
      if ( type == 'search' ) {
        localStorage.savelocalStorage( 'serachResultload', 'true' )
        this.orderby( 'desc' )
        this.resetfilters()
        this.setSearchcategory( categoryName )
      }
      if ( type == 'analyst' ) {
        if ( $( '.analystHeading.tabHeading' ).length > 0 ) {
          $( '.analystHeading.tabHeading' ).html( categoryName )
        }
        var analystDetials = []
        analystDetials['aid'] = post
        analystDetials['strack'] = true
        this.analystbio( analystDetials )

        this.setsearchanalyst( post )
      }

      // events.selectCurrentAcative(currentTab)
    },
    async resetfilters() {
      this.orderby( 'desc' )
      this.resettime( 'clear' )
    },

    entitledModalpopup( a ) {
      // ;(this.uNmae = this.$store.state.auth.user.username), (this.uEmail = this.$store.state.auth.user.email)
      this.uNmae = this.$store.state.auth.user.username
      if ( this.uNmae ) {
        digitalData['entitledLockLink'] = a
        _satellite.track( 'entitledContentPopUp' )
      }
      this.uEmail = this.$store.state.auth.user.email
      $( '#entlitmentuEmail' ).val( this.$store.state.auth.user.email )
      $( '#entlitmentuName' ).val( this.$store.state.auth.user.username )

      this.categoryNameEntlititment = a
      this.$root.$emit( 'bv::show::modal', 'entitledModal' )
    },

    async fetchyoureookPost() {
      this.yourebookLoading = false
      await this.fetchyoureookdata()
      this.yourebookLoading = true
    },

    async getvimeothumbsrc( imgid ) {
      this.getvimeothumbsrcloading = false
      await this.getvimeothumbsrcstore( imgid )
      this.getvimeothumbsrcloading = true
    },
    async fetchApacPost() {
      this.apacLoading = false
      await this.getapacPost()
      this.apacLoading = true
    },
    async fetchCaflPost() {
      this.caflLoading = false
      await this.getcaflPost()
      this.caflLoading = true
    },
    async fetchereaderPost() {
      this.ereaderLoading = false
      await this.fetchereader()
      this.ereaderLoading = true
    },
    async fetchEuropePost() {
      this.europeLoading = false
      await this.getEuropePost()
      this.europeLoading = true
    },
    async fetchLatamPost() {
      this.latamLoading = false
      await this.getLatamPost()
      this.latamLoading = true
    },
    async fetchresearchanalystmorningcall() {
      this.researchanalystmorningcallLoading = false
      await this.getresearchanalystmorningcallPost()
      this.researchanalystmorningcallLoading = true
    },
    async getresearchWebinar() {
      this.researchWebinarLoading = false
      await this.getresearchWebinarPost()
      this.researchWebinarLoading = true
    },

    async fetchSectorSpotlight() {
      this.SectorSpotlightLoading = false
      await this.fetchSectorSpotlightPost()
      this.SectorSpotlightLoading = true
    },

    async fetchmonthlyreports() {
      this.monthlyreportsLoading = false
      await this.getmonthlyreports()
      this.monthlyreportsLoading = true
    },
    async fetchlargecap() {
      this.largecapLoading = false
      await this.getlargecap()
      this.largecapLoading = true
    },
    async fetchwhitepapers() {
      this.whitepapersLoading = false
      await this.getwhitepapers()
      this.whitepapersLoading = true
    },
    async fetchMarketView() {
      this.MarketViewLoading = false
      await this.fetchMarketViewPost()
      this.MarketViewLoading = true
    },
    async fetchSectorsummaryView() {
      this.SectorsummaryLoading = false
      await this.fetchsectorsummaryPost()
      this.SectorsummaryLoading = true
    },
    async fetchequityResearchView() {
      this.equityresearchLoading = false
      await this.fetchequityResearchPost()
      this.equityresearchLoading = true
    },
    async fetchfoucsList() {
      this.focuslistLoading = false
      await this.fetchfocusListPost()
      this.focuslistLoading = true
    },

    async fetchfeaturepost() {
      this.featureLoading = false
      await this.fetchfeature()
      this.featureLoading = true
    },
    async fetchfeaturethirdpost() {
      this.featuresingleLoading = false
      await this.fetchfeaturesingle()
      this.featuresingleLoading = true
    },

    async fetchIPOlisting() {
      this.ipolistingLoading = false
      await this.getipolisting()
      this.ipolistingLoading = true
    },

    async fetchEconomicSummary() {
      this.economicSummaryLoading = false
      await this.geteconomicSummary()
      this.economicSummaryLoading = true
    },

    async fetchTrendWatch() {
      this.trendWatchLoading = false
      await this.gettrendWatch()
      this.trendWatchLoading = true
    },

    async fetchAsiaWatch() {
      this.asiaWatchLoading = false
      await this.getasiaWatch()
      this.asiaWatchLoading = true
    },

    async fetchWonEuropeToday() {
      this.wonEuropeTodayLoading = false
      await this.getwonEuropeToday()
      this.wonEuropeTodayLoading = true
    },

    async fetchderivativesreport() {
      this.derivativesreportloading = false
      await this.getderivativesreport()
      this.derivativesreportloading = true
    },

    async fetchusmarketoverview() {
      this.usmarketoverviewLoading = false
      await this.getusmarketoverview()
      this.usmarketoverviewLoading = true
    },
    async fetchanalystinsightsvideo() {
      this.analystinsightsvideoseriesloading = false
      await this.getanalystinsightsvideoseries()
      this.analystinsightsvideoseriesloading = true
    },


    

    async fetchGlobalLaggards() {
      this.globalLaggardsLoading = false
      await this.getglobalLaggards()
      this.globalLaggardsLoading = true
    },

    async fetchWonGlobalView() {
      this.wonGlobalViewLoading = false
      await this.getwonGlobalView()
      this.wonGlobalViewData = this.$store.state.dashboard.wonglobalview.data
      this.wonGlobalViewLoading = true
    },

    async fetchStrategyView() {
      this.strategyViewLoading = false
      await this.getstrategyView()
      this.strategyViewLoading = true
    },
    async mousemove() {
      $( document ).ready( function () {
        $( '.card' ).on( 'click', '.close', function () {
          $( '.alert-dismissible' ).remove()
        } )
      } )
      jQuery( 'body' ).css( 'overflow', 'hidden' )
      var timeout = null
      $( document ).mousemove( function ( event ) {
        if ( timeout !== null ) {
          jQuery( 'body' ).css( 'overflow', 'visible' )
          clearTimeout( timeout )
        }
        timeout = setTimeout( function () {
          jQuery( 'body' ).css( 'overflow', 'hidden' )
        }, 3000 )
      } )
    },
    getImageurl( videoid ) {
      return this.videoURL( videoid )
    },
    lineLimitpage: function () {
      $( document ).ready( function () {
        // $( '.footerMenu' ).removeClass( 'footerhide' )
        var windowSizeheightsearch = $( window ).height()
        var windowSizeheightexsearch = windowSizeheightsearch - 304
        // $('.dashboardContantSearch').css('min-height', windowSizeheightexsearch + 'px')
        $( '.pdf-viewer__main,.dashboardContantPdf' ).css(
          'min-height',
          windowSizeheightexsearch + 'px'
        )
        store_contents()
        update_ellipsis()
      } )

      var store_contents = function () {
        $( '.ellipsis' ).each( function () {
          var p = $( this )
          p.data( 'ellipsis-storage', p.html() )
        } )
      }

      var update_ellipsis = function () {
        $( '.ellipsis' ).each( function () {
          var p = $( this )
          var max_line_count = p.data( 'ellipsis-max-line-count' )
          var line_height = p.html( '&nbsp' ).outerHeight()
          var max_height = max_line_count * line_height
          p.html( p.data( 'ellipsis-storage' ) )
          var p_height = p.outerHeight()

          while ( p_height > max_height ) {
            var content_arr = p.html().split( ' ' )
            content_arr.pop()
            content_arr.pop()
            content_arr.push( '...' )
            p.html( content_arr.join( ' ' ) )
            p_height = p.outerHeight()
          }
        } )
      }
    },

    showvideopopup( videoid ) {
      // console.log(videoid)
      if ( navigator.userAgent.match( /(PANARAY iPad)/ ) ) {
        this.videoiframe = this.videoURL( videoid, false )

        this.$root.$emit( 'bv::show::modal', 'videomodal' )
        window.open( videoSrc )
      } else {
        $( '.youTubeVideo' ).attr( 'src', this.vimeoUrl )
        this.videoiframe = this.videoURL( videoid, false )
        this.$root.$emit( 'bv::show::modal', 'videomodal' )
      }
    },
    hideModal( id ) {
      this.$root.$emit( 'bv::hide::modal', id )
      $( '.youTubeVideo' ).attr( 'src', $( '.youTubeVideo' ).attr( 'src' ) )
      $( '.youTubeVideo' ).attr( 'src', '' )
    },
    videoURL: function ( src, emptyurl ) {
      // console.log('videoURL src', src)
      var dec = window.atob( src )
      var outputsrc = JSON.parse( dec )
      var video = ''
      var btn = this
      if ( this.types.test( outputsrc ) ) {
        var video =
          '<video width="100%" height="100%" controls><source src="' +
          outputsrc +
          '" type="video/mp4"></video>'
      } else {
        var typesvideo = /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?(?=.*v=((\w|-){11}))(?:\S+)?$/
        if ( outputsrc.match( typesvideo ) ) {
          var videoUrl = outputsrc.replace( /^.*?(\?|&)(v=([^&]+)).*$/i, '$3' )
          var urlv = 'https://www.youtube.com/embed/' + videoUrl
          var video =
            '<iframe class="youTubeVideo" width="100%" height="450" src="' +
            urlv +
            '"></iframe>'
        } else {
          var videoID = outputsrc.split( '/' )

          // console.log('videoURL videoID split', videoID)
          var vimeourl = ''

          this.vimeoUrl =
            SITE_URL +
            'research-analyst-morning-call?id=' +
            videoID[videoID.length - 1]

          //	return 'https://player.vimeo.com/video/' + videoID[videoID.length - 1]
          var video =
            '<iframe class="youTubeVideo" width="100%" height="450" src="' +
            this.vimeoUrl +
            '" frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" data-ready="true"></iframe>'
        }
      }
      // console.log(video)
      return video
    }
  },
  beforeUpdate() {
    this.lineLimitpage()
    var windowSizeDes = $( window ).width()
    var windowSizewidth = windowSizeDes - ( 35 / 100 ) * windowSizeDes

    var globalfontsizeincrease = 5

    if ( windowSizeDes > 1950 ) {
      /*
      if (navigator.userAgent.match(/(MSIE)/) && navigator.userAgent.match(/(.NET CLR)/)) {

        var htmlElement = ['small', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'a', 'li', 'ul', 'b', 'p']
        for (var i = 0; i < htmlElement.length; i++) {
          $(htmlElement[i]).not(".panarayAppdesktop").each(function (index, element) {

            var size = parseInt($(element).css('font-size'), 10);
            //console.log(index, element)
            var increasedsize = size + globalfontsizeincrease;
            // console.log(increasedsize, 'increasedsize', size)

            $(element).css('font-size', increasedsize + 'px');
            $(element).addClass('panarayAppdesktop');

          });
        }
      }
      */
    }
  },
  updated: function () {
    $( '.webinars' ).each( function () {
      var origWidth = $( this ).width()
      var textWidth = $( this ).find( '.webinar' ).width()
      if ( textWidth >= origWidth ) {
        $( this ).find( '.webinar' ).css( 'width', '90%' )
      }
    } )
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/dashboardcontainer.js